import { z } from 'zod';

/** One currency from `GET /api/v1/geo/currencies`. Only consumed fields are typed (rest ignored). */
// `.catchall` keeps unknown keys so the mapper can find the base64/URL flag image WHATEVER the API
// named it (emoji flags don't render on Windows, so this image is what actually shows the flag).
const CurrencyDtoSchema = z
  .object({
    _id: z.string(),
    currency: z.string(),
    currency_name: z.string().nullish(),
    currency_symbol: z.string().nullish(),
    iso2: z.string().nullish(),
    emoji: z.string().nullish(),
  })
  .catchall(z.unknown());

/** Envelope: `{ status, message, data: { currencies } }`. `data` is nullish-tolerant (→ empty). */
export const CurrenciesResponseSchema = z.object({
  status: z.boolean().optional(),
  message: z.string().optional(),
  data: z.object({ currencies: z.array(CurrencyDtoSchema).default([]) }).nullish(),
});

export type CurrencyDto = z.infer<typeof CurrencyDtoSchema>;
